var util = {};

util.toLocale = function (instance,data) {
    var i18n = instance.$i18n;
    var result = getItem(i18n,data.code,data.params);
    if(data.items.length>0) {
        for(var index in data.items) {
            var item = data.items[index];
            var itemResult = getItem(i18n,item.code,item.params);
            if(itemResult !="") {
                result = result + "<br/>" + itemResult;
            }
        }
    }
    return result;
}

function getItem(i18n,code,params) {
    var result = "";
    if(code != null && code !="") {
        if(JSON.stringify(params) == "{}") {
            result = i18n.t(code,params);
        } else {
            result = i18n.t(code);
        }
    }
    return result;
}

export default util;


// WEBPACK FOOTER //
// ./src/util/message.js